import * as React from 'react';
import cx from 'classnames';

import './radio.styles.scss';

export type RadioProps = React.PropsWithChildren<{
  className?: string;
  label?: React.ReactNode;
}> & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const Radio: React.FC<RadioProps> = (props) => {
  const { label: labelContent, className, children, ...otherProps } = props;

  return (
    <div className={cx('radio', 'Radio', className)}>
      <label>
        <input 
          {...otherProps}
          type="radio"
        />
        {labelContent || children}
      </label>
    </div>
  );
};

